import { ChangeEvent, Dispatch, SetStateAction } from "react";

export type HubSpotModuleValue = "contacts" | "leads";

export type HubSpotModuleOption = {
    label: string;
    value: HubSpotModuleValue;
};

export type HubSpotLoginSuccessData = {
    code: string;
    source_type: string;
};

export type HubSpotFooterAction = {
    label: string;
    onSubmit: () => void;
    isLoading?: boolean;
    isDisabled?: boolean;
    iconSrc?: string;
};

export type RegisterFooterAction = (
    key: string,
    action: HubSpotFooterAction | null,
) => void;

export type HubSpotCRMProps = {
    /** Hide the mapping Save button and register it with the modal footer. */
    useHostFooter?: boolean;
    registerFooterAction?: RegisterFooterAction;
    isModal: boolean;
    isCrmView: boolean;
    onMappingSuccess: (response: any) => void | Promise<void>;
    sourceId?: string | number | null;
    name: string;
    onNameChange: (event: ChangeEvent<HTMLInputElement>) => void;
    isAuthLoading: boolean;
    setIsAuthLoading: Dispatch<SetStateAction<boolean>>;
    onLoginSuccess: (data: HubSpotLoginSuccessData) => void | Promise<void>;
    selectedHubspotModule: HubSpotModuleOption | null;
    setSelectedHubspotModule: Dispatch<
        SetStateAction<HubSpotModuleOption | null>
    >;
    isLoginButtonDisabled: boolean;
};

export const HUBSPOT_MODULE_OPTIONS: HubSpotModuleOption[] = [
    {
        label: "Contacts",
        value: "contacts",
    },
    {
        label: "Leads",
        value: "leads",
    },
];
